/**
 * Nemovitosti archive — "Upřesnit výběr" toggle.
 *
 * The plugin renders the advanced filters *expanded*, with the toggle button
 * carrying `hidden` (etrimon-realestate's templates/archive-nemovitost.php).
 * This file reverses that: it reveals the button and puts the panel under its
 * control. That order is deliberate — a type="button" does nothing without
 * JS, so collapsing in the markup would hide the refinements for good on any
 * visit where this bundle fails to load, on a form that is otherwise a plain
 * working GET.
 *
 * Two runtime-only classes carry the state, both styled in
 * _archive-nemovitost.scss:
 *
 *   .listing-refine--collapsible      on the form; arms the collapsed height
 *   .listing-refine__advanced--open   on the panel; slides it back open
 *
 * The slide itself is CSS (grid-template-rows 0fr -> 1fr), not an animated
 * inline height: no layout thrash per frame, and it works on content of
 * unknown height, which is what a taxonomy-driven filter list is.
 *
 * The starting state is read from the button's own aria-expanded rather than
 * assumed closed — the template sets it to "true" when a refinement is
 * already active, and that must survive this file taking over.
 *
 * Concatenated after the vendor bundle by the gulp `scripts` task and enqueued
 * with `defer`, so the document is parsed before this runs — no
 * DOMContentLoaded wrapper needed, same reasoning as main.js.
 */
( function () {
	'use strict';

	var form = document.querySelector( '.listing-refine' );

	if ( ! form ) {
		return;
	}

	var toggle = form.querySelector( '.listing-refine__toggle' );

	if ( ! toggle ) {
		return;
	}

	var panel = document.getElementById( toggle.getAttribute( 'aria-controls' ) );

	if ( ! panel ) {
		return;
	}

	/**
	 * Applies one open/closed state to both elements.
	 *
	 * @param {boolean} open Whether the advanced filters should be shown.
	 */
	function setExpanded( open ) {
		toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		panel.classList.toggle( 'listing-refine__advanced--open', open );
	}

	form.classList.add( 'listing-refine--collapsible' );
	toggle.hidden = false;

	setExpanded( 'true' === toggle.getAttribute( 'aria-expanded' ) );

	toggle.addEventListener( 'click', function () {
		setExpanded( 'true' !== toggle.getAttribute( 'aria-expanded' ) );
	} );
}() );
